import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { inject, NgModule, provideAppInitializer } from '@angular/core';
import { Observable, of } from 'rxjs';

import { TranslateLoader } from './translate.loader';
import { TranslateModule } from './translate.module';
import { TranslateService } from './translate.service';
import { LangChangeEvent } from './translate.store';
import { TranslateDebugService } from './translate-debug.service';

class DummyLoader implements TranslateLoader {
  getTranslation(_lang: string): Observable<any> {
    return of({});
  }
}

@NgModule({
  declarations: [],
  exports: [TranslateModule],
  imports: [
    TranslateModule.forRoot({
      extend: true,
      isolate: false,
      loader: {
        provide: TranslateLoader,
        useClass: DummyLoader,
      },
    }),
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideAppInitializer(() => {
      inject(TranslateDebugService);
    }),
  ],
})
export class SharedUtilsTranslateModule {
  constructor(translate: TranslateService) {
    translate.onLangChange.subscribe((event: LangChangeEvent) => {
      Object.keys(translate.translations).forEach((lang) => {
        if (lang !== event.lang) {
          translate.resetLang(lang);
        }
      });
    });
  }
}
